import React, {useState} from "react"
import FlashBarFromURL from "src/components/commonComponents/flashBarFromURL/flashBarFromURL";
import {
    Box, Button,
    Container,
    Flashbar, FlashbarProps,
    FormField,
    Header,
    Input,
    SpaceBetween,
    Textarea
} from "@amzn/awsui-components-react-v3";
import {PageHeader} from "src/components/commonComponents/pageHeader/pageHeader";
import {convertStringToArray} from "src/utils/CommonUtils";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {getAwsCredentials} from "src/authentication/cognito";
import AWS from "aws-sdk";


const RequirementsPage = () => {

    const [taskName, setTaskName] = useState("");
    const [domainName, setDomainName] = useState("");
    const [input, setInput] = useState("");
    const [output, setOutput] = useState("")

    const Location = useLocation();
    const urlParams = queryString.parse(Location.search);
    const workflowName = urlParams["domain_name"] as string;
    const inputList = convertStringToArray(input)
    const outputList = convertStringToArray(output);
    const taskDetails = {
        domainName,
        taskName,
        inputList,
        outputList
    };
    const [ flashBarItems, setFlashBarItems ] = useState<FlashbarProps.MessageDefinition[]>([]);

    const submitTaskDetails = async() => {
        setFlashBarItems([{
            "header": " Submitting Task Details ",
            "type": "success",
            "loading": true,
            "dismissible": true,
            onDismiss: () => setFlashBarItems([])
        }]);
        try {
            await getAwsCredentials();
            const lambdaClient = new AWS.Lambda({apiVersion: '2015-03-31',region:'us-east-1'});

            var params = {
                FunctionName: "updateLambda",
                Payload: JSON.stringify({
                    ownerName: workflowName,
                    taskDetails: taskDetails
                }),
            };
            console.log("lambda is invoked")
            await lambdaClient.invoke(params).promise();
            setFlashBarItems([{
                "header": `Successfully Submitted the Details for ${taskName} \n 
                   For using the submitted task in workflow visit https://test.snow.aft.amazon.dev/#/workflowCreationCanvas?workflow_name=TESTING`,
                "type": "success",
                "dismissible": true,
                onDismiss: () => setFlashBarItems([])
            }]);
            setDomainName("")
            setTaskName("")
            setInput("")
            setOutput("")

        } catch(e) {
            console.log(e);
            throw e;
        }
    }

    return  (
        <div>
            <FlashBarFromURL />
            <Flashbar items={[...flashBarItems]} />
            <PageHeader title={`Onboarding of a new task `} />
            <Box variant="div" margin={{ top: "l" }}>
                <Container
                    header={
                        <Header variant="h2">New Task Onboarding Details</Header>
                    }
                >
                    <SpaceBetween size="xs">
                        <FormField
                            label="Domain Name"
                        >
                            <Input
                                onChange={({ detail }) => setDomainName(detail.value)}
                                value={domainName}
                                type="text"
                            />
                        </FormField>
                        <FormField
                            label="Task Name"
                        >
                            <Input
                                onChange={({ detail }) => setTaskName(detail.value)}
                                value={taskName}
                                type="text"
                            />
                        </FormField>

                        <FormField
                            label="Input Fields"
                            description="Input Required for the task"
                            constraintText="One field is allowed in one line."
                        >
                            <Textarea
                                value={input}
                                onChange={({ detail }) => setInput(detail.value)}
                            />
                        </FormField>
                        <FormField
                            label="Output Fields"
                            description="Output fields for the task"
                            constraintText="One field is allowed in one line."
                        >
                            <Textarea
                                value={output}
                                onChange={({ detail }) => setOutput(detail.value)}
                            />
                        </FormField>


                        <Button
                            onClick={submitTaskDetails}
                            variant="primary"
                        >
                            Submit
                        </Button>
                    </SpaceBetween>
                </Container>
            </Box>
        </div>
    )

}

export default RequirementsPage;

